// Translation manager
// Simple i18n manager for Spanish only
class I18nManager {
  constructor() {
    this.currentLang = "en";
    this.translations = {};
    document.documentElement.lang = "en";
  }

  getText(key) {
    // No translations, just return the key
    return key;
  }

  updatePageTexts() {
    // Update all elements with data-i18n, but just use the key
    document.querySelectorAll("[data-i18n]").forEach((element) => {
      const key = element.getAttribute("data-i18n");
      if (
        element.tagName === "INPUT" &&
        (element.type === "text" || element.type === "email")
      ) {
        element.placeholder = key;
      } else if (element.tagName === "INPUT" && element.type === "submit") {
        element.value = key;
      } else {
        element.textContent = key;
      }
    });
    // Update title and meta description
    document.title = `EPC Spain`;
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.content = "Energy Performance Certificates for homes in Spain";
    }
  }
}

// Initialize and export i18n manager
const i18n = new I18nManager();
window.i18n = i18n;

export default i18n;

export { I18nManager };
